import { Stack, Typography } from "@mui/material";

import { ShiftEditorDatePicker } from "./DatePicker";
import { DebugTooltip } from "./DebugTooltip";
import { IncentiveLevelPicker } from "./IncentiveLevelPicker";
import { PositionPicker } from "./PositionPicker";
import { ShiftHistory } from "./ShiftHistory";
import { ShiftEditorShiftTypePicker } from "./ShiftTypePicker";
import { StaffJobPicker } from "./StaffJobPicker";
import { StatusPicker } from "./StatusPicker";
import { TimePickers } from "./TimePickers";
import { ShiftEditorUnitPicker } from "./UnitPicker";

const ShiftEditor = () => <></>;

ShiftEditor.StaffJobPicker = StaffJobPicker;
ShiftEditor.UnitPicker = ShiftEditorUnitPicker;
ShiftEditor.DatePicker = ShiftEditorDatePicker;
ShiftEditor.ShiftTypePicker = ShiftEditorShiftTypePicker;
ShiftEditor.TimePickers = TimePickers;
ShiftEditor.PositionPicker = PositionPicker;
ShiftEditor.StatusPicker = StatusPicker;
ShiftEditor.IncentiveLevelPicker = IncentiveLevelPicker;
ShiftEditor.ShiftHistory = ShiftHistory;
ShiftEditor.DebugTooltip = DebugTooltip;

ShiftEditor.Section = ({
  children,
  title,
  className,
}: {
  children: React.ReactNode;
  title: string;
  className?: string;
}) => (
  <Stack direction="column" className={`shift-editor-section ${className}`}>
    <Typography className="shift-editor-section-title">{title}</Typography>
    {children}
  </Stack>
);

export { ShiftEditor };
